import { getTranslations } from "next-intl/server";
import EmptySearch from "@/assets/icons/empty-search.svg";
import { buttonVariants } from "@/components/ui/button";
import {
  getNoResultsOffer,
  getNoResultsOfferCatering,
} from "@/features/diets/api/get-no-results-offer";
// MPL-3886: the "150 zł off your first order" coupon campaign has ended, so the
// promo badge is disabled. Kept commented out so it can be brought back later.
// import { NoResultsBadge } from "@/features/diets/components/no-results-badge";
import { NoResultsOfferCatering } from "@/features/diets/components/no-results-offer-catering";
import { NoResultsOfferCoupon } from "@/features/diets/components/no-results-offer-coupon";
import { NoResultsOfferDiets } from "@/features/diets/components/no-results-offer-diets";
import { RecommendedDietsSection } from "@/features/diets/components/recommended-diets-section";
import { Link } from "@/i18n/navigation";
import { cn } from "@/lib/utils";

type DietsNoFoundProps = {
  url?: string;
  search?: string;
};

export const DietsNoFound = async ({ url, search }: DietsNoFoundProps) => {
  const t = await getTranslations("diets");

  const offer = await getNoResultsOffer(search);
  const offerCatering = await getNoResultsOfferCatering(
    offer?.catering ?? null,
  );

  if (offerCatering) {
    return (
      <div className="flex w-full basis-full flex-col justify-center">
        <header className="mb-6">
          <h2 className="font-medium text-xl lg:text-2xl">
            {t("no_results_offer.title")}
          </h2>
          <h3 className="mt-1 text-base">{t("no_results_offer.subtitle")}</h3>
        </header>
        <div className="flex w-full flex-col gap-4">
          <NoResultsOfferCatering catering={offerCatering} />
          {offer?.discount_code && (
            <div className="px-4">
              <NoResultsOfferCoupon
                code={offer.discount_code}
                description={offer.discount_description}
              />
            </div>
          )}
        </div>
        <div className="mt-4 w-full basis-full rounded-lg bg-brand-grey1 p-4">
          <NoResultsOfferDiets cateringId={offerCatering.id} />
        </div>
      </div>
    );
  }

  return (
    <div className="flex w-full basis-full flex-col items-center justify-center">
      {/* MPL-3886: coupon campaign ended – promo badge disabled.
      <NoResultsBadge
        className="order-2 max-lg:mt-10 lg:order-1 lg:mb-10"
        cta={t("no_results_badge.cta")}
        ctaLink="/burn"
        description={t("no_results_badge.description")}
        title={t("no_results_badge.title")}
      /> */}
      <div className="order-1 flex flex-col items-center justify-center max-lg:mt-10 lg:order-2">
        <EmptySearch />
        <h2 className="mt-6 mb-4 block max-w-xl text-center font-medium text-2xl lg:text-3xl">
          {t("no_results_text")}
        </h2>
        <h3 className="mb-6 text-center text-xl">{t("reset_filter_text")}</h3>
        <p>
          <Link
            href={url || "/diets"}
            title={t("reset_all_filters")}
            className={cn(buttonVariants({ variant: "outline" }), "h-14 px-8")}
          >
            {t("reset_all_filters")}
          </Link>
        </p>
      </div>
      <div className="order-3 mt-10 w-full basis-full">
        <RecommendedDietsSection />
      </div>
    </div>
  );
};
